import { useState, useEffect } from "react";
import { useResponsive } from "./useResponsive";

export const useScrollShadow = (threshold = 60) => {
  const [showShadow, setShowShadow] = useState(false);
  const { isMobile, isTablet } = useResponsive();
  const isMobileOrTablet = isMobile || isTablet;

  useEffect(() => {
    let scrollContainer = window;

    // On mobile/tablet, the middle scrollable container holds the content
    if (isMobileOrTablet) {
      const mobileScrollContent = document.querySelector(
        "[data-scroll-container]"
      );
      if (mobileScrollContent) {
        scrollContainer = mobileScrollContent;
      }
    } else {
      // On desktop, use .main-panel if available
      const mainPanel = document.querySelector(".main-panel");
      if (mainPanel && mainPanel.scrollHeight > mainPanel.clientHeight) {
        scrollContainer = mainPanel;
      }
    }

    const handleScroll = () => {
      const scrollY =
        scrollContainer === window
          ? window.scrollY
          : scrollContainer.scrollTop;
      setShowShadow(scrollY > threshold);
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [threshold, isMobileOrTablet]);

  return showShadow;
};